import { useState, useRef, useEffect } from "react";
import dropdown from "../../assets/images/dropdown.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Translation } from "react-i18next";
import { upperCase } from "../../utils/manipulateText";

const MultiSelectMenu = ({
  data,
  title,
  selectedParam,
  setSelectedParam,
  showFilterQuery = false,
  fullWidth = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filterQuery, setFilterQuery] = useState("");
  const dropdownRef = useRef(null);

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
  };

  const handleItemSelect = (key) => {
    if (selectedParam.includes(key)) {
      setSelectedParam(selectedParam.filter((item) => item !== key));
    } else {
      setSelectedParam([...selectedParam, key]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`relative inline-block text-left ${fullWidth ? "w-full" : ""}`}
      ref={dropdownRef}
    >
      <button
        className={`sm:inline-flex border bg-gray-200 rounded-md transition-all ease-out transition-fast text-xs font-bold py-2 px-3 ${
          fullWidth ? "w-full" : ""
        }`}
        onClick={handleButtonClick}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          {selectedParam.length > 0 && (
            <span
              className="text-xs font-bold px-1 rounded bg-white shadow mr-1"
              style={{
                display: "inline-block",
                minWidth: "20px",
                textAlign: "center",
              }}
            >
              {selectedParam.length}
            </span>
          )}
          <Translation>{(t) => upperCase(t(title.toLowerCase()))}</Translation>
        </div>
        <img src={dropdown} alt="" style={{ width: "15px", height: "15px" }} />
      </button>

      {isOpen && (
        <div
          className={`absolute w-auto bg-white border border-gray-300 shadow-lg rounded-md p-2 z-50 ${
            fullWidth ? "w-full" : ""
          }`}
        >
          {showFilterQuery && (
            <input
              type="text"
              placeholder="Search..."
              className="w-full p-2 mb-2 border rounded-md text-sm"
              value={filterQuery}
              onChange={(e) => setFilterQuery(e.target.value)}
            />
          )}
          <div className="flex flex-col space-y-2 font-semibold text-gray-600">
            {Object.entries(data)
              .filter(([_key, value]) =>
                value.toLowerCase().includes(filterQuery.toLowerCase())
              )
              .map(([key, value]) => (
                <div
                  key={key}
                  className="flex items-center justify-between rounded-md cursor-pointer p-1 px-2 hover:text-indigo-500 hover:bg-gray-200"
                  onClick={() => handleItemSelect(key)}
                >
                  <p>{value}</p>
                  {selectedParam.includes(key) && (
                    <FontAwesomeIcon icon={faCheck} />
                  )}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelectMenu;
